import React, { useCallback, useEffect, useMemo } from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { PopularItemResponse } from "../types/response/storeItems";
import PopularItem from "./popularItem";
import CustomFlatList from "./flatlist";
import useCartItems from "../libs/hooks/useCartItems";
import Text from "./text";
import { TABLET_PC } from "../libs/utils/constants";
import translate from "../libs/locale";
import useQueryItems from "../libs/hooks/useQueryItems";
import { useNavigation } from "@react-navigation/native";
import { QUERY_UTIL } from "../libs/utils/dataUtils";
import { MaterialIcons } from "@expo/vector-icons";
import variables from "../assets/variables";

const TopItems = ({
  numColumns,
  title,
  query = { is_available: true, limit: QUERY_UTIL.limit } as any,
  horizontal = true,
}) => {
  const navigation = useNavigation<any>();

  const [data, loading] = useQueryItems(query);

  const cartItems = useCartItems();

  const renderItem = ({ item }: { item: PopularItemResponse }) => {
    if (item.meta) {
      return <View style={styles.dummy} />;
    }
    const available =
      item.store?.is_active && item.store?.is_serving && item.stock > 0;
    const cartItemForItemId =
      cartItems[item.store?._id]?.items.filter((it) => it._id == item._id) ||
      [];
    return (
      <PopularItem
        item={item}
        enabled={available}
        cartItems={cartItemForItemId}
        squared
        style={styles.item}
      />
    );
  };

  const dataToRender = useMemo(() => {
    const tempDtaToRender = [...data];
    const numCol = TABLET_PC ? numColumns : 2;
    const length = data?.length;
    const numRows = Math.ceil(length / numCol);
    if (!horizontal) {
      for (let i = 0; i < numRows * numCol - length; i++) {
        dataToRender.push({ meta: true, _id: `06${i}` } as any);
      }
    }
    return tempDtaToRender;
  }, [data]);

  const props = { horizontal };
  if (!horizontal) {
    props["numColumns"] = TABLET_PC ? numColumns : 2;
  }

  const openViewAll = useCallback(() => {
    navigation.navigate(
      "CategoryDetail" as never,
      {
        catName: title,
        id: query.category,
      } as never
    );
  }, []);

  if (!data?.length) {
    return null;
  }

  return (
    <>
      <View style={styles.header}>
        <Text style={[styles.topStoresTitle]}>{title}</Text>
        <Pressable onPress={openViewAll} style={styles.viewAllContainer}>
          <Text style={[styles.topStoresTitle, styles.viewAll]}>
            {translate("viewAll")}
          </Text>
          <MaterialIcons
            name="arrow-back-ios"
            size={18}
            color={variables.$brandColor}
            style={styles.nextArrow}
          />
        </Pressable>
      </View>
      <CustomFlatList
        data={dataToRender}
        renderItem={renderItem}
        keyExtractor={(item) => item._id}
        {...props}
      />
    </>
  );
};

const styles = StyleSheet.create({
  nextArrow: {
    transform: [{ rotateY: "180deg" }],
    marginLeft: 0,
  },
  header: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  topStoresTitle: {
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: 16,
    lineHeight: 20,
    color: "#636E72",
    marginVertical: 5,
  },
  viewAllContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  viewAll: {
    fontSize: 12,
    color: variables.$brandColor,
  },
  dummy: {
    flex: 1,
    padding: 10,
  },
  item: {
    width: 175,
  },
});

export default TopItems;
